import React, {useState} from "react";
import {FieldAttributes, useField} from "formik";
import "./index.scss";

interface Props {
    label: string;
    suffix?: string;
    outputValue?: string;
    messageInfoObj?: any;
}

export const OutputValue = ({name, messageInfoObj, label, outputValue, suffix}: FieldAttributes<Props>) => {
    const [field] = useField({name});

    const [needToShowMessage, setNeedToShowMessage] = useState(false);
    const messageInfo = messageInfoObj ? messageInfoObj : null;

    const onClick = () => {
        if (messageInfo) {
            setNeedToShowMessage(!needToShowMessage);
        }
    };

    return (
        <div className={'output-value'}>

            <span className='output-value__label'>{label}</span>
            <span onClick={onClick} className={`output-value${messageInfo ? '-pointer' : ''}__value`}>
				{outputValue ? outputValue : field.value} {suffix ? suffix : ''}</span>

            <div className={'info-message-span'} style={{display: needToShowMessage ? 'block' : 'none'}}>
                {messageInfo}
            </div>

        </div>
    )
};